export default __webpack_public_path__ + "static/media/0xdae5f1590db13e3b40423b5b5c5fbf175515910b.9a562e43.svg";